<div class="ship-details-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>Shipment Details</h2>
        <mat-dialog-actions>
            <button mat-raised-button class="send-email">Email Label</button>
            
            <button mat-raised-button class="print">Reprint Label</button>
            <button mat-raised-button class="close-button-medium" mat-dialog-close>Close</button>
        </mat-dialog-actions>
        <button class="btn close-button-small" mat-dialog-close>
            <i class="material-icons">close</i>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="shipmentStatus"></ng-container>
        <ng-container [ngTemplateOutlet]="trackingDetails"></ng-container>
        <ng-container [ngTemplateOutlet]="shipmentDetails"></ng-container>

        <div class="horizontal-medium">
            <ng-container [ngTemplateOutlet]="shipmentInformation"></ng-container>
            <ng-container [ngTemplateOutlet]="paymentInformation"></ng-container>
        </div>
    </mat-dialog-content>
</div>

<ng-template #shipmentStatus>
    <div class="section shipment-status">
        <h4 class="section-title">Shipment Status</h4>
        <div class="section-content">
            <div class="content-items">

            </div>
        </div>
    </div>
</ng-template>

<ng-template #trackingDetails>
    <div class="section tracking-details">
        <h4 class="section-title">{{'TrackingDetails'|translate}}</h4>
        <div class="section-content">
            <div class="content-items">
                <div class="content-item">
                    <div class="key">Tracking Number</div>
                    <div class="value">
                        {{ quote.TrackingNumber || 'N/A' }}
                        <button mat-button class="link" (click)="isShowTrackingDetailsTable = !isShowTrackingDetailsTable">
                            {{ isShowTrackingDetailsTable ? 'View Less' : 'View Details' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tracking-details-table" *ngIf="isShowTrackingDetailsTable"></div>
    </div>
</ng-template>

<ng-template #shipmentDetails>
    <div class="section shipment-details">
        <h4 class="section-title">Shipment Details</h4>
        <div class="section-content">
            <div class="content-items shipment-details">
                <div class="content-item">
                    <span class="key">Ship Date</span>
                    <span class="value">{{ simplifyDate(quote.ShipDate) }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Tracking Number</span>
                    <span class="value">{{ quote.TrackingNumber || 'N/A' }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Confirmation Number</span>
                    <span class="value">{{ quote.ConfirmationNumber || 'N/A' }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Parcel Pro Notify</span>
                    <span class="value">{{ 'N/A' }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Service Type</span>
                    <span class="value">{{ quote.ServiceCode }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Package Type</span>
                    <span class="value">{{ quote.PackageCode }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Est. Weight</span>
                    <span class="value">{{ quote.Weight }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Insured Value</span>
                    <span class="value">{{ quote.InsuredValue }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #shipmentInformation>
    <div class="section shipment-information">
        <h4 class="section-title">Shipment Information</h4>
        <div class="section-content">
            <div class="content-items shipment-information">
                <h5 class="content-items-title">Ship To</h5>
                <div class="content-item">
                    <span class="key">Company Name</span>
                    <span class="value">{{ quote.ShipTo.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Address</span>
                    <span class="value">{{ quote.ShipTo.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">City/State</span>
                    <span class="value">{{ quote.ShipTo.City + ', ' + quote.ShipTo.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Zip/Country</span>
                    <span class="value">{{ quote.ShipTo.Zip + ', ' + quote.ShipTo.Country }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Phone Number</span>
                    <span class="value">{{ quote.ShipTo.TelephoneNo }}</span>
                </div>
            </div>
            <div class="content-items shipment-information">
                <h5 class="content-items-title">Ship From</h5>
                <div class="content-item">
                    <span class="key">Contact Name</span>
                    <span class="value">{{ quote.ShipFrom.FirstName + ' ' + quote.ShipFrom.LastName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Company Name</span>
                    <span class="value">{{ quote.ShipFrom.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Address</span>
                    <span class="value">{{ quote.ShipFrom.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">City/State</span>
                    <span class="value">{{ quote.ShipFrom.City + ', ' + quote.ShipFrom.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Zip/Country</span>
                    <span class="value">{{ quote.ShipFrom.Zip + ', ' + quote.ShipFrom.Country }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Phone Number</span>
                    <span class="value">{{ quote.ShipFrom.TelephoneNo }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentInformation>
    <div class="section payment-information">
        <h4 class="section-title">Payment Information</h4>
        <div class="section-content">
            <div class="content-items payment-information">
                <div class="content-item bill-to">
                    <span class="key">Bill To</span>
                    <span class="value">{{ quote.BillToAccount }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Est. Shipping & Insurance</span>
                    <span class="value">{{ quote.EstimatedCost }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Fuel Surcharges</span>
                    <span class="value">{{ quote.FuelSurcharges }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Adult Signature Required</span>
                    <span class="value">{{ quote.IsReturnAdultSignature }}</span>
                </div>
                <div class="content-item">
                    <span class="key">Saturday Delivery</span>
                    <span class="value">{{ quote.IsSaturdayDelivery }}</span>
                </div>
                <div class="content-item total">
                    <span class="key">Your Total</span>
                    <span class="value">{{ quote.EstimatedCost }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>